/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-12-26 16:11:31
 * @LastAuthor   : xiaoyao
 * @lastTime     : 2020-01-02 15:00:22
 */
require('./detail')

import Mock from 'mockjs2'
import { builder } from '@/mock/util'



const getCustomerFileData = (id) => {
    const result = [{
        "id": "491259527207007027297291",
        "owner": "\u90ed\u5bcc\u6210123",
        "mobile": "13628036466",
        "plate_no": "\u5dddA3Q30Q",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-08-30 16:35:03",
        "status": "\u9884\u7ea6\u5df2\u62a5\u4ef7",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "2(\u59d3\u540d2)"
    }, {
        "id": "491451213982728601613678",
        "owner": "\u5f20\u6c38\u660c",
        "mobile": "13628036666",
        "plate_no": "\u5dddA3Q30Q",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-05-29 22:35:03",
        "status": "\u9884\u7ea6\u672a\u62a5\u4ef7",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "2(\u59d3\u540d2)"
    }, {
        "id": "491452356925535334472927",
        "owner": "s1897",
        "mobile": "1362803666",
        "plate_no": "\u5dddA3Q30Q",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-05-16 16:23:26",
        "status": "\u9884\u7ea6\u5df2\u62a5\u4ef7",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "2(\u59d3\u540d2)"
    }, {
        "id": "491602056683979161630702",
        "owner": "xiao",
        "mobile": "18888888888",
        "plate_no": "88888",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-08-31 16:43:00",
        "status": "\u9884\u7ea6\u672a\u62a5\u4ef7",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "1(\u59d3\u540d1)"
    }, {
        "id": "491602349660727193684450",
        "owner": "sdsdcdcsdc",
        "mobile": "13628036666",
        "plate_no": "\u5dddA3Q30Q",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-05-31 15:06:35",
        "status": "\u9884\u7ea6\u5df2\u62a5\u4ef7",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "1(\u59d3\u540d1)"
    }, {
        "id": "491602530985522380899197",
        "owner": "hhhh",
        "mobile": "18888888888",
        "plate_no": "\u5dddA3Q30Q",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-05-15 15:38:44",
        "status": "\u65e0\u6548",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "1(\u59d3\u540d1)"
    }, {
        "id": "491602965217201664012188",
        "owner": "sdsdcdcsdczzzz",
        "mobile": "13628036666",
        "plate_no": "\u5dddA3Q30Q",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "",
        "status": "\u5931\u8d25",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "2(\u59d3\u540d2)"
    }, {
        "id": "491603199827273420890516",
        "owner": "Mr.han",
        "mobile": "18888888888",
        "plate_no": "\u5dddA3Q30Q",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-05-29 16:02:03",
        "status": "\u9884\u7ea6\u5df2\u62a5\u4ef7",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "2(\u59d3\u540d2)"
    }, {
        "id": "491668164376422195274020",
        "owner": "\u563f\u563f\u563f",
        "mobile": "123333333",
        "plate_no": "\u5dddA3Q30Q",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-05-31 14:55:57",
        "status": "\u9884\u7ea6\u5df2\u62a5\u4ef7",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "3(\u59d3\u540d3)"
    }, {
        "id": "497446454195074048010732",
        "owner": "\u97e9sir",
        "mobile": "13628036666",
        "plate_no": "\u5dddA6WD7D",
        "model": "",
        "initial_date": "",
        "company": "",
        "business_expiration_date": "",
        "preset_time": "2019-08-16 15:16:26",
        "status": "\u9884\u7ea6\u5df2\u62a5\u4ef7",
        "batch": "A",
        "type": "\u9996\u5e74",
        "remark": "",
        "user_attach": "4"
    }]
    return builder({
        page:1,
        page_size:10,
        total:10,
        pages:10,
        data: result
    })
}

Mock.mock(/\/custommer/, 'get', getCustomerFileData)


// WEBPACK FOOTER //
// ./src/mock/services/list/customer-file/index.js